Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $(".js-login-order-validation-form");

    if ($wrapper.length < 1) return;

    var wrapper = $wrapper.get(0);

    wrapper.formData = {
        orderCode: '',
        phone: '',
        reCaptchaCode: '',
        orderGuid: ''
    };

    // reCAPTCHA
    var captchaWidgetId;
    var captchaId = "validationCaptcha";
    var $captchaElement = $wrapper.find("#" + captchaId);
    var $captchaContainer = $wrapper.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;

    wrapper.initRecaptcha = function () {
        if (!captchaEnabled)
            return;
        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': wrapper.recaptchaCallback
            });
        }
    };

    wrapper.validateRecaptcha = function () {

        if (!captchaEnabled)
            return true;

        wrapper.formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;
        if (wrapper.formData.reCaptchaCode) {
            $captchaContainer.find('.error-recaptcha').hide();
            res = true;
        } else {
            $captchaContainer.find('.error-recaptcha').show();
        }
        return res;
    };

    wrapper.resetRecaptcha = function () {
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    wrapper.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    wrapper.recaptchaCallback = function () {
        wrapper.validateRecaptcha();
    };

    wrapper.bindForm = function () {

        wrapper.isValid = true;

        $('.js-translator', $wrapper).each(function (index, translator) {
            var $translator = $(translator),
                key = $translator.data('key'),
                text = key ? LhApp.Function.getText('Common:' + key) : '';
            if (text) $translator.html(text);
        });

        wrapper.checkConsents = function () {
            var data = [];
            var checkboxes = $('.form-row.consent.checkbox', $wrapper);
            $.each(checkboxes, function (e, el) {
                var chkbx = $('.checkbox-wrapper > input', el);
                data.push({
                    type: chkbx.attr('id'),
                    source: 'Request Return',
                    approved: chkbx.prop("checked")
                });
            });
            if (data.length > 0) {
                window.ConsentsManager.insertConsents(data);
            } else {
                if (wrapper.validate()) {
                    wrapper.submit();
                } else {
                    $wrapper.removeClass('x-loading');
                }
            }
        };

        $(".js-submit-order-validate-contactInfo", $wrapper).on('click', function (e) {
            var validation1 = wrapper.validateRecaptcha();
            var validation2 = wrapper.validate();

            if (!validation1 || !validation2)
                return;

            $wrapper.addClass('x-loading');

            if (LhApp.Context.IsConsentsEnabled) {
                wrapper.checkConsents();
            } else {
                wrapper.submit();
            }
        });

        wrapper.addValidators();

        wrapper.formBound = true;
    };

    wrapper.autoSubmit = function () {
        wrapper.formData.orderCode = LhApp.Function.QueryString.getValueOf("OrderCode");
        wrapper.formData.phone = LhApp.Function.QueryString.getValueOf("phone");
        wrapper.formData.orderGuid = LhApp.Function.QueryString.getValueOf("OrderGuid");

        wrapper.submit();   
    };

    wrapper.submit = function () {
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.LoginOrder.Messages.ValidateLoginOrder(wrapper.formData));
    };

    wrapper.addValidators = function () {

        $('.js-return-orderCode', $wrapper).on('keyup change', $.debounce(50, function (e) {
            var $this = $(this);
            var temp = '';

            if ($this.val().length >= 2) {
                temp = $this.val()[0] + $this.val()[1];
            }

            if (temp != 'AA' && temp != 'AΑ' && temp != 'ΑA' && temp != 'ΑΑ' && temp != 'Aa' && temp != 'aA' && temp != 'Αa' && temp != 'aΑ' && temp != 'Aα' && temp != 'αA' && temp != 'Αα' && temp != 'αΑ') {
                var newText = e.target.value;
                string_to_slug(newText);
                wrapper.formData.orderCode = newText;
            } else {
                if ($this.val().length >= 2) {
                    $this.val('A' + $this.val().substring(2));
                } else {
                    $this.val('A');
                }
            }

            wrapper.validateOrderCode();
        }));

        $(".js-return-phone", $wrapper).on('keyup change', $.debounce(50, function (e) {
            var str = e.target.value;
            str = str.replace(/\s/g, '');
            if (str !== $(this).val()) {
                $(this).val(str);
            }
            wrapper.formData.phone = str;

            wrapper.validateOrderPhone();
        }));

        $('.js-return-orderCode, .js-return-phone', $wrapper).on('keyup change', $.debounce(50, function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();

                var val = wrapper.validateOrderPhone();
                var val2 = wrapper.validateOrderCode();

                if (val && val2) {
                    $(".js-submit-order-validate-contactInfo", $wrapper).trigger('click');
                }
            }
        }));

        var $consents = $('.form-row.consent input[type="checkbox"]', $wrapper);
        $consents.on('click', function () {
            var $consent = $(this);
            if (!$consent.prop('checked')) {
                $consent.closest('.form-row').addClass('with-error');
                $('.validator', $consent.closest('.form-row')).addClass('error');
            } else {
                $consent.closest('.form-row').removeClass('with-error');
                $('.validator', $consent.closest('.form-row')).removeClass('error');
            }
        });

        wrapper.validateOrderCode = function () {

            if (!wrapper.formData.orderCode) {
                $('.js-return-orderCode', $wrapper).closest('.form-row').addClass('with-error');
                $('.validator', $('.js-return-orderCode', $wrapper).closest('.form-row')).addClass('error');
                return false;
            }

            $('.js-return-orderCode', $wrapper).closest('.form-row').removeClass('with-error');
            $('.validator', $('.js-return-orderCode', $wrapper).closest('.form-row')).removeClass('error');

            return true;

        };

        wrapper.validateOrderPhone = function () {

            if (!wrapper.formData.phone) {
                $('.js-return-phone', $wrapper).closest('.form-row').addClass('with-error');
                $('.validator', $('.js-return-phone', $wrapper).closest('.form-row')).addClass('error');
                return false;
            }

            $('.js-return-phone', $wrapper).closest('.form-row').removeClass('with-error');
            $('.validator', $('.js-return-phone', $wrapper).closest('.form-row')).removeClass('error');

            return true;

        };

        wrapper.validateConsents = function () {

            var consentValid = true;

            $consents.each(function (index, consent) {
                var $consent = $(consent);
                $consent.closest('.form-row').removeClass('with-error');
                if (!$consent.prop('checked')) {
                    $consent.closest('.form-row').addClass('with-error');
                    $('.validator', $consent.closest('.form-row')).addClass('error');
                } else {
                    $consent.closest('.form-row').removeClass('with-error');
                    $('.validator', $consent.closest('.form-row')).removeClass('error');
                }
                consentValid = consentValid && $consent.prop('checked');
            });

            return consentValid;

        };

        wrapper.validate = function () {
            var result = true;
            result = wrapper.validateOrderCode() && result;
            result = wrapper.validateOrderPhone() && result;
            result = wrapper.validateConsents() && result;
            return result;
        };

    };

    //NEEDS REVIEW
    function string_to_slug(str) {
        str = stringReplace(str, 'a', 'A');
        str = stringReplace(str, 'α', 'A');
        str = stringReplace(str, 'Α', 'A');
        str = stringReplace(str, 'ά', 'A');
        str = stringReplace(str, 'Ά', 'A');
        if (str !== $('.js-return-orderCode', $wrapper).val()) {
            $('.js-return-orderCode', $wrapper).val(str);
        }
    }

    function stringReplace(str, search, replacement) {
        var fix = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        return str.replace(new RegExp(fix, 'g'), replacement);
    }

    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, wrapper, wrapper.submit);

    wrapper.handleErrorOnGetRequest = function (envelope) {
        $wrapper.removeClass('x-loading');

        sessionStorage.removeItem('prevGlobalId');
        sessionStorage.removeItem('OrderLoginReturnModel');

        if (!wrapper.formBound) {
            wrapper.bindForm();
        } else {
            $('.form-msg-error', $wrapper).hide();

            if (envelope.message.data.validation) {
                $('.js-not-found-error', $wrapper).show();
            } else {
                $('.js-generic-error', $wrapper).text(LhApp.Function.getText("Common:ReturnFormGenericError"));
                $('.js-generic-error', $wrapper).show();
            }
           
            wrapper.resetRecaptcha();

            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: localError.offset().top - 50
                }, 100, 'swing');

            }, 100);
        }

    };

    Vendd.MessageBus.subscribe(Vendd.LoginOrder.Messages.ValidateLoginOrderFailure, wrapper, function (envelope) {
        wrapper.handleErrorOnGetRequest(envelope);
    });

    Vendd.MessageBus.subscribe(Vendd.LoginOrder.Messages.ValidateLoginOrderError, wrapper, function (envelope) {
        wrapper.handleErrorOnGetRequest(envelope);
    });

    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, wrapper, wrapper.initRecaptcha);

    if (LhApp.Function.QueryString.getValueOf("OrderCode").length > 0 &&
        LhApp.Function.QueryString.getValueOf("phone").length > -1 &&
        LhApp.Function.QueryString.getValueOf("OrderGuid").length > -1) {
        wrapper.autoSubmit();
    } else {
        wrapper.bindForm();
    }

});
